import styled from 'styled-components';

const HeroSection = styled.section`
  position: relative;
  background: var(--frost);
  padding: 140px 24px 70px;
  text-align: center;
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  max-width: 750px;
  margin: 0 auto;
`;

const Label = styled.span`
  display: inline-block;
  font-family: 'Inter', sans-serif;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: var(--sage);
  margin-bottom: 14px;
`;

const Title = styled.h1`
  font-family: 'Lora', serif;
  font-size: clamp(2rem, 4.5vw, 3rem);
  font-weight: 600;
  color: var(--text-dark);
  margin: 0 0 18px;
  line-height: 1.2;
`;

const Subtitle = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 400;
  color: var(--text-muted);
  line-height: 1.7;
  max-width: 560px;
  margin: 0 auto;
`;

const PageHero = ({ label, title, subtitle }) => {
  return (
    <HeroSection>
      <ContentWrapper>
        {label && <Label>{label}</Label>}
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </ContentWrapper>
    </HeroSection>
  );
};

export default PageHero;
